export function fetchBasketRequest(state) {
  return state;
}

export function fetchBasketSuccess(state, action) {
  const { data: { items: nextItems, ...nextState } } = action;

  const findNextItem = sku => nextItems.find(nextItem => nextItem.sku === sku);
  const findOldItem = sku => state.items.find(oldItem => oldItem.sku === sku);

  const existingItemsInOldOrder = state.items.map(oldItem => findNextItem(oldItem.sku)).filter(Boolean);
  const newItems = nextItems.filter(nextItem => !findOldItem(nextItem.sku));

  return {
    ...state,
    ...nextState,
    items: [...newItems, ...existingItemsInOldOrder],
  };
}

export function fetchBasketError(state, action) {
  return {
    ...state,
    error: action.error,
  };
}
